// 流程编号
export const flowCode = 'F001'